import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const OAuth2CallbackPage: React.FC = () => {
  const { handleCallback } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const processCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');

      if (!code || !state) {
        setError('Authorization code or state missing');
        return;
      }

      try {
        await handleCallback(code, state);
        const returnTo = sessionStorage.getItem('post_auth_redirect') || '/';
        sessionStorage.removeItem('post_auth_redirect');
        navigate(returnTo, { replace: true });
      } catch (e) {
        console.error('Callback error:', e);
        setError('Failed to complete authentication');
      }
    };

    processCallback();
  }, [handleCallback, navigate, searchParams]);

  if (error) {
    return (
      <div className="error-container">
        <h2>Authentication Failed</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/login')}>Try Again</button>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <h2>Completing sign in...</h2>
      <p>Please wait while we redirect you.</p>
    </div>
  );
};
